import {
  SW_TAG_ENCRYPT_AND_SAVE_IMAGES,
  SW_TAG_GENERATE_AND_SAVE_CONTEXT,
  SW_TAG_GENERATE_AND_SAVE_MOMENTS_CHUNKS,
  SW_TAG_GENERATE_AND_SAVE_TAGS_AND_EMOTION,
} from '@/constants'

interface RegisterSyncsArgs {
  tag:
    | typeof SW_TAG_GENERATE_AND_SAVE_CONTEXT
    | typeof SW_TAG_GENERATE_AND_SAVE_MOMENTS_CHUNKS
    | typeof SW_TAG_GENERATE_AND_SAVE_TAGS_AND_EMOTION
    | typeof SW_TAG_ENCRYPT_AND_SAVE_IMAGES
}

export const registerSyncs = async ({ tag }: RegisterSyncsArgs) => {
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    const registration = await navigator.serviceWorker.ready
    try {
      await registration.sync.register(tag)
      console.log('Sync registered', tag)
    } catch (error) {
      console.error('Error registering sync', error)
    }
  } else {
    console.error('Service Worker is not supported')
  }
}
